/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Viewbutton1Inputs */

const id_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat`)
};

const ms_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat`)
};

const da_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se`)
};

const de_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansehen`)
};

const en_us2_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const es_es2_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const es_mx2_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const fil_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan`)
};

const fr_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir`)
};

const it_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza`)
};

const hu_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megtekintés`)
};

const nl_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijken`)
};

const no_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis`)
};

const pl_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz`)
};

const pt_br2_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizar`)
};

const pt_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const ro_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi`)
};

const fi_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä`)
};

const sv_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa`)
};

const vi_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem`)
};

const tr_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görüntüle`)
};

const cs_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit`)
};

const bg_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преглед`)
};

const ru_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотр`)
};

const uk_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути`)
};

const ar_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض`)
};

const hi_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देखें`)
};

const th_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดู`)
};

const ja_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示`)
};

const zh_cn2_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看`)
};

const zh_hant1_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢視`)
};

const ko_sandboxes_viewbutton1 = /** @type {(inputs: Sandboxes_Viewbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보기`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Sandboxes_Viewbutton1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_viewbutton1 = /** @type {((inputs?: Sandboxes_Viewbutton1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Viewbutton1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_viewbutton1(inputs)
	if (locale === "ms") return ms_sandboxes_viewbutton1(inputs)
	if (locale === "da") return da_sandboxes_viewbutton1(inputs)
	if (locale === "de") return de_sandboxes_viewbutton1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_viewbutton1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_viewbutton1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_viewbutton1(inputs)
	if (locale === "fil") return fil_sandboxes_viewbutton1(inputs)
	if (locale === "fr") return fr_sandboxes_viewbutton1(inputs)
	if (locale === "it") return it_sandboxes_viewbutton1(inputs)
	if (locale === "hu") return hu_sandboxes_viewbutton1(inputs)
	if (locale === "nl") return nl_sandboxes_viewbutton1(inputs)
	if (locale === "no") return no_sandboxes_viewbutton1(inputs)
	if (locale === "pl") return pl_sandboxes_viewbutton1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_viewbutton1(inputs)
	if (locale === "pt") return pt_sandboxes_viewbutton1(inputs)
	if (locale === "ro") return ro_sandboxes_viewbutton1(inputs)
	if (locale === "fi") return fi_sandboxes_viewbutton1(inputs)
	if (locale === "sv") return sv_sandboxes_viewbutton1(inputs)
	if (locale === "vi") return vi_sandboxes_viewbutton1(inputs)
	if (locale === "tr") return tr_sandboxes_viewbutton1(inputs)
	if (locale === "cs") return cs_sandboxes_viewbutton1(inputs)
	if (locale === "bg") return bg_sandboxes_viewbutton1(inputs)
	if (locale === "ru") return ru_sandboxes_viewbutton1(inputs)
	if (locale === "uk") return uk_sandboxes_viewbutton1(inputs)
	if (locale === "ar") return ar_sandboxes_viewbutton1(inputs)
	if (locale === "hi") return hi_sandboxes_viewbutton1(inputs)
	if (locale === "th") return th_sandboxes_viewbutton1(inputs)
	if (locale === "ja") return ja_sandboxes_viewbutton1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_viewbutton1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_viewbutton1(inputs)
	return ko_sandboxes_viewbutton1(inputs)
});
export { sandboxes_viewbutton1 as "sandboxes.viewButton" }